module.exports = __webpack_public_path__ + "img/bg_e_rt.545e148e.png";